import { API_URL } from "@/constants/envVariables";

import { handleApiResponse } from "@/api/handleApiResponse";

import { buildAuthHeaders, getAuthCredentials } from "@/helpers/authHeaders";

import { ApiOrgInfo } from "@/types";

export const getOrgInfo = async (token: string): Promise<ApiOrgInfo> => {
  const response = await fetch(`${API_URL}/organization`, {
    method: "GET",
    credentials: getAuthCredentials(),
    headers: {
      "Content-Type": "application/json",
      ...buildAuthHeaders(token),
    },
  });

  return handleApiResponse(response);
};
